<template>
  <v-card class="dialog-card">
    <ModalHeader
      helpFileName="CreateScene"
      icon="mdi-cube-outline"
      modalTitle="Create Scene"
      :modalSubtitle="tabs[tab]"
      @close="emit('close')" />
    <div
      style="display: flex"
      class="px-3">
      <!--Tabs-->
      <v-tabs
        class="tab-container"
        density="comfortable"
        direction="vertical"
        v-model="tab">
        <v-tab style="min-width: 50px">
          <v-icon class="mr-2">mdi-file-image</v-icon>
        </v-tab>
        <v-tab style="min-width: 50px">
          <v-icon class="mr-2">mdi-cube-scan</v-icon>
        </v-tab>
        <v-tab style="min-width: 50px">
          <v-icon class="mr-2">mdi-tune-variant</v-icon>
        </v-tab>
      </v-tabs>
      <!--Tabs-->
      <div
        class="mx-3 modal-body"
        style="width: 330px; height: 500px">
        <v-window
          :touch="touchless()"
          class="mt-2"
          direction="vertical"
          style="width: 100%"
          v-model="tab">
          <v-window-item
            id="assets-onair-wrapper"
            style="height: 500px; margin-bottom: 10px">
            <div>
              <Assets
                :containerHeight="'calc(100% - 30px) !important'"
                v-if="delayTab === 0"
                :selectMode="true"
                :dense="true"
                @selected="selectAssets" />
            </div>
          </v-window-item>
          <v-window-item style="height: 500px">
            <Templates
              :containerHeight="'calc(100% - 30px) !important'"
              v-if="delayTab === 1"
              :selectMode="true"
              :dense="true"
              @selected="selectTemplates" />
          </v-window-item>
          <!-- Template presets -->
          <v-window-item style="height: 500px">
            <Templates
              :containerHeight="'calc(100% - 30px) !important'"
              v-if="delayTab === 2"
              filter="presets"
              :selectMode="true"
              :dense="true"
              @selected="selectTemplates" />
          </v-window-item>
        </v-window>
      </div>
    </div>
    <div class="modal-footer">
      <v-btn
        block
        :loading="create_scene_loading"
        tabindex="0"
        @keyup.enter="add_assets()"
        @click="add_assets()"
        :disabled="
          selected_assets.length == 0 &&
          selected_templates.length == 0 &&
          selected_scenes.length == 0
        "
        color="primary"
        variant="flat">
        <v-icon class="mr-2">mdi-cube-send</v-icon>
        Create Scenes
      </v-btn>
    </div>
  </v-card>
</template>
<script setup>
import { $http } from '../../stores/http.js';
import { deluge } from '@/stores/deluge.js';
import { ref, defineProps, watch } from 'vue';
import Tag from '../Shared/Tag.vue';
// import AssetCard from '../Assets/AssetCard.vue';
import WideCard from '../Shared/WideCard.vue';
import HelpButton from '../Help-Hints/HelpButton.vue';
import ModalHeader from '../Shared/Modals/ModalHeader.vue';
import { iconByType } from '../../utils/assetTypeToMDIIcon.js';
const touchless = () => {
  return false;
};

// Use dynamic imports to avoid bundling these components into main chunk
import { defineAsyncComponent } from 'vue';
const Templates = defineAsyncComponent(
  () => import('../Templates/Templates.vue')
);
const Assets = defineAsyncComponent(() => import('../Assets/Assets.vue'));

const assetChild = ref();

const emit = defineEmits(['close']);
const tabs = ref([
  'From an Asset',
  'From a Template',
  'From a Template Preset',
  'From an Existing Scene',
]);
const props = defineProps(['qid', 'channel_did', 'containerHeight']);
const selected_assets = ref([]);
const selected_scenes = ref([]);

const selected_templates = ref([]);
const create_scene_loading = ref(false);
const tab = ref(0);
const delayTab = ref(0);
watch(tab, (newVal) => {
  // Without delay the components update during the transition breaking the UI
  setTimeout(() => {
    delayTab.value = newVal;
  }, 150);
});

function sortByTimestamp(a, b, order) {
  if (order === 'asc') {
    return new Date(b.timestamp) - new Date(a.timestamp);
  }
  return new Date(a.timestamp) - new Date(b.timestamp);
}

function add_assets() {
  var create_scenes_obj = {
    qid: props.qid,
    asset_ids: [],
    template_ids: [],
    scene_ids: [],
  };
  for (var i = 0; i < selected_assets.value.length; i++) {
    create_scene_loading.value = true;
    create_scenes_obj.asset_ids.push(selected_assets.value[i]);
  }
  for (i = 0; i < selected_templates.value.length; i++) {
    create_scene_loading.value = true;
    create_scenes_obj.template_ids.push(selected_templates.value[i]);
  }
  for (i = 0; i < selected_scenes.value.length; i++) {
    create_scene_loading.value = true;
    create_scenes_obj.scene_ids.push(selected_scenes.value[i]);
  }

  $http(
    'POST',
    '/dynamic_engine/scenes_from_assets',
    JSON.stringify(create_scenes_obj)
  ).then(() => {
    selected_assets.value = [];
    create_scene_loading.value = false;
    emit('close');
  });
}
function selectAssets(newVal) {
  selected_assets.value = newVal;
}
function selectTemplates(newVal) {
  selected_templates.value = newVal;
}
</script>

<style scoped>
#assets-onair-wrapper .assets-container {
  max-height: calc(105vh - 640px);
}

.selected {
  background-color: var(--v-primary-base);
  color: rgb(255, 255, 255);
}

.tag-container {
  display: flex;
  align-items: center;
}

.tag-icon {
  width: 24px;
  height: 24px;
  border-radius: 50%;
  margin-right: 8px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.tag-name {
  font-size: 14px;
  font-weight: bold;
  margin: 2px;
}

/* Default background color for tags */
.tag-default {
  opacity: 0.4 !important;
  color: white;
}

.button-highlight {
  background-color: var(--v-primary-base);
  color: white;
}
</style>
